// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3fNOt","unreadBadge":"styles_unreadBadge__1eEL0","modalContent":"styles_modalContent__19N7h","modal":"styles_modal__1XM9-"};